import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  convertToCommas,
  DollarFormatterNonGridValue,
} from "../../common/commonFunctions";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
} from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import { Icon } from "@iconify/react";
import { appColor } from "../../common/constants";

const kpiDefaults = [
  {
    date: "",
    totalClient: "0",
    totalSymbol: 0,
    totalShare: 0,
    dayPnl: 0,
    typeOfData: "Locate-App",
    filledCount: 0,
    totalCount: 0,
  },
  {
    date: "",
    totalClient: "0",
    totalSymbol: 0,
    totalShare: 0,
    dayPnl: 0,
    typeOfData: "Locate-Use",
    filledCount: 0,
    totalCount: 0,
  },
  {
    date: "",
    totalClient: "0",
    totalSymbol: 0,
    totalShare: 0,
    dayPnl: 0,
    typeOfData: "PRE-BORROW",
    filledCount: 0,
    totalCount: 0,
  },
  {
    date: "",
    totalClient: "0",
    totalSymbol: 0,
    totalShare: 0,
    dayPnl: 0,
    typeOfData: "INQUIRY",
    filledCount: 0,
    totalCount: 0,
  },
];

const LocatesKpi = (props: any) => {
  const [iconSize] = useState("1.5rem");
  const [avatarSize] = useState(40);
  const avatarColor = appColor;
  const [totalClient, setTotalClient] = useState(0);
  const [locatePNL, setLocatePNL] = useState(0);
  const [preBorrowPNL, setPreBorrowPNL] = useState(0);
  const [locate, setLocate] = useState(kpiDefaults[0]);
  const [preBorrow, setPreborrow] = useState(kpiDefaults[2]);
  const [locateUsed, setLocateUsed] = useState(kpiDefaults[1]);
  const [inquiry, setInquiry] = useState(kpiDefaults[3]);

  useEffect(() => {
    if (props && _.isArray(props?.kpiData)) {
      setCardValues(props?.kpiData);
    } else {
      setCardValues(kpiDefaults);
    }
  }, [props]);

  useEffect(()=>{
    props?.setDate(moment().format("MM-DD-yyyy"))
  },[])

  const setCardValues = (kpi: any) => {
    const totalClients = _.sumBy(kpi, "totalClient");
    setTotalClient(totalClients);

    const locateAppr = _.find(
      kpi,
      (item: any) => item?.typeOfData === "Locate-App"
    );
    const locatePrB = _.find(
      kpi,
      (item: any) => item?.typeOfData === "PRE-BORROW"
    );
    const locateUse = _.find(
      kpi,
      (item: any) => item?.typeOfData === "Locate-Use"
    );

    const inquiryStats = _.find(
      kpi,
      (item: any) => item?.typeOfData === "INQUIRY"
    );

    if (inquiryStats) {
      setInquiry(inquiryStats);
    }else{
      setInquiry(kpiDefaults[3]);
    }
   
    if (locateAppr) {
      setLocate(locateAppr);
    }else{
      setLocate(kpiDefaults[0]);
    }
    if (locatePrB) {
      setPreBorrowPNL(locatePrB?.dayPnl);
      setPreborrow(locatePrB);
    }else{
      setPreBorrowPNL(0);
      setPreborrow(kpiDefaults[2]);
    }
    if (locateUse) {
      setLocatePNL(locateUse?.dayPnl);
      setLocateUsed(locateUse);
    } else{
      setLocatePNL(0);
      setLocateUsed(kpiDefaults[1]);
    }

  };

  return (
    <div className="row d-flex justify-content-between" style={{ width: "100.5%" }}>
      {/* <div className="col-xxl-2 col-lg-2 col-md-2 ml-2 col-sm-12" style={{ paddingRight: 0 }}>
        <Card className="h-100 w-100" 
        
        >
          <CardHeader
            className="pr-4 py-1"
            subheader={
              <div className="d-flex flex-row justify-content-between">
                <Typography className="d-flex flex-row align-items-center mr-2">
                  <MuiAvatar
                    sx={{
                      width: avatarSize,
                      height: avatarSize,
                      marginRight: 1,
                    }}
                  >
                    <Icon
                      icon={"system-uicons:calendar-date"}
                      color={avatarColor}
                      fontSize={iconSize}
                    ></Icon>
                  </MuiAvatar>
                  Date
                </Typography>
                
              </div>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-between w-100 pb-1">
            <div className="d-flex flex-column align-items-start">
              <div className="d-flex flex-row justify-content-between w-100">
                <div
                  className="row d-flex flex-row"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="d-flex flex-row justify-content-between align-items-center"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    
                    <div className={`${moment().isAfter(date, "day")?'past-date-bg':''}`}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disableFuture
                          openTo="day"
                          className="onFocusOutTermDateID"
                          views={["year", "month", "day"]}
                          maxDate={moment().toDate()}
                          value={date}
                          inputFormat="yyyy-MM-dd"
                          InputProps={{
                            notched: false,
                            style: { fontSize: 13, color: "#212529" },
                          }}
                          onChange={(newValue: any) => {
                            setDate(newValue);
                            props?.setDate(newValue)
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              variant="outlined"
                              // sx={{
                              //   "& .MuiInputBase-input": {
                              //     height: "0.4rem",
                              //     width: "4.4rem",
                              //   },
                              // }}
                              
                              className="locate-kpi-date-picker"
                              {...params}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                   
                  </div>
                  
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div> */}

  <div
        className="col ms-1 sm-md-mt "
        style={{ paddingRight: 0, paddingLeft: 0 }}
      >
        <Card className="h-100">
          <CardHeader className="py-1"
            subheader={<Typography>Inquiry</Typography>}
            avatar={
              <MuiAvatar
                sx={{ width: avatarSize, height: avatarSize, marginRight: 0 }}
              >
                <Icon
                  icon={"tabler:list-search"}
                  color={avatarColor}
                  fontSize={iconSize}
                ></Icon>
              </MuiAvatar>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-between w-100 pt-0 pbtm-5">
            <div className="d-flex flex-column align-items-start w-100">
              <div className="d-flex flex-row justify-content-between w-100">
                <div className="row d-flex flex-column align-items-start justify-content-between me-5">
                  <div
                    className="d-flex flex-row justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Total</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        inquiry?.totalCount && !_.isNaN(inquiry?.totalCount)
                          ? convertToCommas(inquiry?.totalCount)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Clients</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        inquiry?.totalClient && !_.isNaN(inquiry?.totalClient)
                          ? convertToCommas(inquiry?.totalClient)
                          : 0
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="row"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Shares</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        inquiry?.totalShare && !_.isNaN(inquiry?.totalShare)
                          ? convertToCommas(inquiry?.totalShare)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Symbols</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        inquiry?.totalSymbol && !_.isNaN(inquiry?.totalSymbol)
                          ? convertToCommas(inquiry?.totalSymbol)
                          : 0
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <div
        className="col ms-1 sm-md-mt "
        style={{ paddingRight: 0, paddingLeft: 0 }}
      >
        <Card className="h-100" 
        // sx={{ border: '1px solid #0000004f', borderRadius:'0px' }}
        >
          <CardHeader className="py-1"
            subheader={<Typography>Locate Approved</Typography>}
            avatar={
              <MuiAvatar
                sx={{ width: avatarSize, height: avatarSize, marginRight: 0 }}
              >
                <Icon
                  icon={"marketeq:file-folder-approved-2"}
                  color={avatarColor}
                  fontSize={iconSize}
                ></Icon>
              </MuiAvatar>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-between w-100 pt-0 pbtm-5">
            <div className="d-flex flex-column align-items-start w-100">
              <div className="d-flex flex-row justify-content-between w-100">
                <div className="row d-flex flex-column align-items-start justify-content-between me-5">
                  <div
                    className="d-flex flex-row justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Total</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locate?.totalCount && !_.isNaN(locate?.totalCount)
                          ? convertToCommas(locate?.totalCount)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Clients</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locate?.totalClient && !_.isNaN(locate?.totalClient)
                          ? convertToCommas(locate?.totalClient)
                          : 0
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="row"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Shares</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locate?.totalShare && !_.isNaN(locate?.totalShare)
                          ? convertToCommas(locate?.totalShare)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Symbols</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locate?.totalSymbol && !_.isNaN(locate?.totalSymbol)
                          ? convertToCommas(locate?.totalSymbol)
                          : 0
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <div
        className="col ms-1 sm-md-mt"
        style={{ paddingRight: 0, paddingLeft: 0 }}
      >
        <Card className="h-100 me-1" 
        // sx={{ border: '1px solid  #0000004f',borderRadius:'0px' }}
        >
          <CardHeader
          className="py-1"
            subheader={<Typography>Locate Used</Typography>}
            avatar={
              <MuiAvatar>
                <Icon
                  icon={"material-symbols-light:energy-program-time-used-outline"}
                  color={avatarColor}
                  fontSize={iconSize}
                ></Icon>
              </MuiAvatar>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-between w-100 pt-0 pbtm-5">
            <div className="d-flex flex-column align-items-start w-100">
              <div className="d-flex flex-row justify-content-between w-100">
                <div className="row d-flex flex-column align-items-start justify-content-between me-5">
                  <div
                    className="d-flex flex-row justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Total</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locateUsed?.totalCount &&
                        !_.isNaN(locateUsed?.totalCount)
                          ? convertToCommas(locateUsed?.totalCount)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Clients</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locateUsed?.totalClient &&
                        !_.isNaN(locateUsed?.totalClient)
                          ? convertToCommas(locateUsed?.totalClient)
                          : 0
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="row"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Shares</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locateUsed?.totalShare &&
                        !_.isNaN(locateUsed?.totalShare)
                          ? convertToCommas(locateUsed?.totalShare)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Symbols</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        locateUsed?.totalSymbol &&
                        !_.isNaN(locateUsed?.totalSymbol)
                          ? convertToCommas(locateUsed?.totalSymbol)
                          : 0
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <div
        className="col sm-md-mt"
        style={{ paddingRight: 0, paddingLeft: 0 }}
      >
        <Card className="h-100 me-1" 
        // sx={{ border: '1px solid #0000004f' , borderRadius:'0px'}}
        >
          <CardHeader className="py-1"
            subheader={<Typography>Pre-Borrow</Typography>}
            avatar={
              <MuiAvatar
                sx={{ width: avatarSize, height: avatarSize, marginRight: 0 }}
              >
                <Icon
                  fontSize={iconSize}
                  icon={"arcticons:borrowed"}
                  color={avatarColor}
                ></Icon>
              </MuiAvatar>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-between w-100 pt-0 pbtm-5">
            <div className="d-flex flex-column align-items-start w-100">
              <div className="d-flex flex-row justify-content-between w-100">
                <div className="row d-flex flex-column align-items-start justify-content-between me-5">
                  <div
                    className="d-flex flex-row justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Total</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        preBorrow?.totalCount && !_.isNaN(preBorrow?.totalCount)
                          ? convertToCommas(preBorrow?.totalCount)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Clients</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        preBorrow?.totalClient &&
                        !_.isNaN(preBorrow?.totalClient)
                          ? convertToCommas(preBorrow?.totalClient)
                          : 0
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="row "
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="justify-content-between"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Shares</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        preBorrow?.totalShare && !_.isNaN(preBorrow?.totalShare)
                          ? convertToCommas(preBorrow?.totalShare)
                          : 0
                      }`}
                    />
                  </div>
                  <div
                    className="justify-content-between mt-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className="me-2">Symbols</Typography>
                    <Chip
                      className="pr-2"
                      label={`${
                        preBorrow?.totalSymbol &&
                        !_.isNaN(preBorrow?.totalSymbol)
                          ? convertToCommas(preBorrow?.totalSymbol)
                          : 0
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="col-xxl-2 col-lg-2 col-md-2 ml-2 col-sm-12 sm-md-mt me-1" style={{ paddingRight: 0, paddingLeft: 0 }}>
        <Card className="h-100" 
        // sx={{ border: '1px solid #0000004f' , borderRadius:'0px'}}
        >
          <CardHeader
          className="py-1"
            subheader={<Typography>PNL</Typography>}
            avatar={
              <MuiAvatar
                sx={{ width: avatarSize, height: avatarSize, marginRight: 0 }}
              >
                <Icon
                  icon={"healthicons:dollar"}
                  color={avatarColor}
                  fontSize={iconSize}
                ></Icon>
              </MuiAvatar>
            }
          ></CardHeader>
          <CardContent className="d-flex justify-content-start w-100 pt-0 pbtm-5 me-1">
            <div className="row d-flex row">
              <div className="d-flex flex-row justify-content-between pr-0">
                <div className="justify-content-start">
                  <Typography>Locate</Typography>
                </div>
                <div className="justify-content-end">
                  <Chip
                    label={`${
                      locatePNL && !_.isNaN(locatePNL)
                        ? DollarFormatterNonGridValue(locatePNL)
                        : "$0"
                    }`}
                  />
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between mt-2">
                <Typography>Pre Borrow</Typography>
                <Chip
                  label={`${
                    preBorrowPNL && !_.isNaN(preBorrowPNL)
                      ? DollarFormatterNonGridValue(preBorrowPNL)
                      : "$0"
                  }`}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LocatesKpi;
